export const types = {
    SET_GET_EXCHANGE_RATES: '[EXCHANGE] SET GET EXCHANGE RATES'
}